import { render, staticRenderFns } from "./GetPhoneNumber.vue?vue&type=template&id=9b1afbb8&scoped=true&"
import script from "./GetPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./GetPhoneNumber.vue?vue&type=script&lang=js&"
import style0 from "./GetPhoneNumber.vue?vue&type=style&index=0&id=9b1afbb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b1afbb8",
  null
  
)

component.options.__file = "GetPhoneNumber.vue"
export default component.exports